import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import CommandButton from '../CommandButton/CommandButton';
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog';
import s from './CommandPanel.module.scss';
import bs from '../../styles/bootstrap-overrides.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import { WidgetVisibility } from '../../utils/widgetManager';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { COMMAND_MODE_MANUAL, COMMAND_MODE_AUTO } from '../../constants/index';

const CommandPanel = ({ commandButtonStatus, sendCommand, intl, userProfileWidgets = {}, flowSequences, isTaggedOut, showAllCommands = false }) => {
  const [active, setActive] = useState(false);
  const [commandId, setCommandId] = useState(0);
  const [commandType, setCommandType] = useState(COMMAND_MODE_MANUAL);

  const handleClose = () => setActive(false);

  const handleCommand = (commandId, cType) => {
    setActive(true);
    setCommandId(commandId);
    setCommandType(cType);
  };

  const handleConfirm = () => {
    sendCommand(commandId, commandType);
    handleClose();
  };

  const commandButtons = flowSequences && flowSequences.filter(x => x.ShowCommand);

  const dialogTitle = intl.formatMessage({
    id: 'command.areyousureyouwanttoactionthecommand',
    defaultMessage: 'Are you sure you want to action the command?'
  });

  const startCommandText = intl.formatMessage({
    id: 'commandPanel.iotCommandStart',
    defaultMessage: 'START'
  });

  const stopCommandText = intl.formatMessage({
    id: 'commandPanel.iotCommandStop',
    defaultMessage: 'STOP'
  });

  const commandStatus = commandButtonStatus || isTaggedOut === 1 ? true : false;

  const CommandPanelComponent = showAllCommands ? ShowAllCommandComponents : ShowBasicCommandComponents;

  return (
    <CommandPanelComponent userProfileWidgets={userProfileWidgets} startCommandText={startCommandText} stopCommandText={stopCommandText} dialogTitle={dialogTitle} handleConfirm={handleConfirm} handleClose={handleClose} active={active} handleCommand={handleCommand} commandButtons={commandButtons} commandStatus={commandStatus} showAllCommands={showAllCommands} />
  );
};

CommandPanel.propTypes = {
  commandButtonStatus: PropTypes.bool.isRequired,
  sendCommand: PropTypes.func.isRequired,
  flowSequences: PropTypes.array.isRequired,
  isTaggedOut: PropTypes.number.isRequired,
  userProfileWidgets: PropTypes.object.isRequired
};

export default injectIntl(CommandPanel);


const ShowAllCommandComponents = ({ userProfileWidgets, startCommandText, stopCommandText, dialogTitle, handleConfirm, handleClose, active, commandButtons, handleCommand, commandStatus }) => {
  return (
    <Fragment>
      <ConfirmDialog title={dialogTitle} onConfirm={handleConfirm} onClose={handleClose} showDialog={active} />
      <div className={s.commandPanel}>
        <h4>
          <FormattedMessage id="unitOverview.systemOperations" defaultMessage="System Operations" />
        </h4>
        <Row className={s.startStopButton}>

          <Col
            md={6}
            xs={6}
            className={s.commandbutton}
            key={`commandPanel-2000`}
            style={WidgetVisibility(userProfileWidgets, `IOTALPHA2COMMANDBUTTON_START`)}
          >
            <CommandButton
              key={`command-2000`}
              disabled={commandStatus}
              sendCommand={handleCommand}
              command={'2000'}
              cType={COMMAND_MODE_MANUAL}
              name={startCommandText}
              title={startCommandText}
            />
          </Col>
          <Col
            md={6}
            xs={6}
            className={s.commandbutton}
            key={`commandPanel-2199`}
            style={WidgetVisibility(userProfileWidgets, `IOTALPHA2COMMANDBUTTON_STOP`)}
          >
            <CommandButton
              key={`command-2199`}
              disabled={commandStatus}
              sendCommand={handleCommand}
              command={'2199'}
              cType={COMMAND_MODE_MANUAL}
              name={stopCommandText}
              title={stopCommandText}
            />
          </Col>
        </Row>

        <Row className={s.buttonHolder}>
          {commandButtons &&
            commandButtons.map(button =>
              button.SequenceCode !== 0 && button.SequenceCode !== 2000 && button.SequenceCode !== 2199 && button.SequenceCode !== 2020 ? (
                <Col
                  className={s.commandbutton}
                  md={6}
                  xs={6}
                  key={`commandPanel-${button.SequenceCode}`}
                  style={WidgetVisibility(userProfileWidgets, `IOTALPHA2COMMANDBUTTON_ALLSHOWCOMMANDS`)}
                >
                  <CommandButton
                    key={`command-${button.SequenceCode}`}
                    disabled={commandStatus}
                    sendCommand={handleCommand}
                    command={button.SequenceCode}
                    name={button.Name.toUpperCase()}
                    cType={button.Name == 'AUTO' ? COMMAND_MODE_AUTO : COMMAND_MODE_MANUAL}
                    title={button.Name.toUpperCase() || button.Description}
                  />
                </Col>
              ) : (
                ''
              )
            )}
        </Row>
      </div>
    </Fragment>
  )
}



const ShowBasicCommandComponents = ({ userProfileWidgets, startCommandText, stopCommandText, dialogTitle, handleConfirm, handleClose, active, commandButtons, handleCommand, commandStatus }) => {
  return (

    <Fragment>
      <ConfirmDialog title={dialogTitle} onConfirm={handleConfirm} onClose={handleClose} showDialog={active} />
      <div>
        <Row className={s.startStopButton}>
          <Col
            md={6}
            xs={6}
            className={s.commandbutton}
            key={`commandPanel-2000`}
            style={WidgetVisibility(userProfileWidgets, `IOTALPHA2COMMANDBUTTON_START`)}
          >
            <CommandButton
              key={`command-2000`}
              disabled={commandStatus}
              sendCommand={handleCommand}
              command={'2000'}
              cType={COMMAND_MODE_MANUAL}
              name={startCommandText}
              title={startCommandText}
            />
          </Col>
          <Col
            md={6}
            xs={6}
            className={s.commandbutton}
            key={`commandPanel-2199`}
            style={WidgetVisibility(userProfileWidgets, `IOTALPHA2COMMANDBUTTON_STOP`)}
          >
            <CommandButton
              key={`command-2199`}
              disabled={commandStatus}
              sendCommand={handleCommand}
              command={'2199'}
              cType={COMMAND_MODE_MANUAL}
              name={stopCommandText}
              title={stopCommandText}
            />
          </Col>

        </Row>

      </div>
    </Fragment>
  )
}